import createIcon from '../../createIcon';

/**
 * @component @name Quickreply
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNzUgMy41QzIxLjc1IDIuNCAyMC44NSAxLjUgMTkuNzUgMS41SDMuNzVDMi42NSAxLjUgMS43NiAyLjQgMS43NiAzLjVMMS43NSAyMS41TDUuNzUgMTcuNUgxNC43NVY5LjVIMjEuNzVWMy41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIyLjI1IDE1LjVIMjAuMDVMMjEuNzUgMTEuNUgxNi43NVYxNy41SDE4Ljc1VjIyLjVMMjIuMjUgMTUuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Quickreply = createIcon('Quickreply', [
  [
    'path',
    {
      d: 'M21.75 3.5C21.75 2.4 20.85 1.5 19.75 1.5H3.75C2.65 1.5 1.76 2.4 1.76 3.5L1.75 21.5L5.75 17.5H14.75V9.5H21.75V3.5Z',
      key: '11xhce',
    },
  ],
  ['path', { d: 'M22.25 15.5H20.05L21.75 11.5H16.75V17.5H18.75V22.5L22.25 15.5Z', key: 'uhn0mm' }],
]);

export default Quickreply;
